import { DIALOG_OPEN, DIALOG_CLOSE } from '../actionConstants';
import defaultState from './dialogDefaultState';
import { Dialog } from './dialogTypes';

export default function (state: Dialog = defaultState, action: any) {
  const options = action.payload?.options || {};
  switch (action.type) {
    case DIALOG_OPEN:
      return {
        type: action.payload.dialog,
        closable: options.closable, // TODO jost keep options object?
        options: options,
      };
    case DIALOG_CLOSE:
      return {};
    default:
      return state;
  }
}
